import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'acces-rapide-item',
  templateUrl: 'acces-rapide-item.component.html',
  styleUrls: ['acces-rapide-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IonicModule, FormsModule, TranslateModule],
  standalone: true,
})
export class AccesRapideItemComponent {
  title = input<string>();
  iconName = input<string>();
  fontAwesomeName = input<string>();
  svgFileName = input<string>();

  clickEvent = output<boolean>();

  clickOnItem() {
    this.clickEvent.emit(true);
  }
}
